import { useEffect } from 'react';
import { useCEProductSelector } from '../../bitf-customization-engine/useCEProductSelector';

export default function CEProductCollectionSelector({ productSelectorHook, localization, resetCustomization }) {
  const { collections, selectedCollection, setCollection, initProductSelector } =
    productSelectorHook || useCEProductSelector({ localization });

  // Initialize data on mount
  useEffect(() => {
    if (!collections || collections.length === 0) {
      initProductSelector({ localization });
    }
  }, [initProductSelector, collections, localization]);

  return (
    <div className="collection-selector__container">
        {collections.map((collection) => (
          <button
            key={collection.id}
            className={`collection-image-button ${selectedCollection?.id === collection.id ? 'selected' : ''}`}
            onClick={() => {
              setCollection(collection);
            }}
          >
            {collection.image?.url && (
              <img
                draggable={false}
                src={collection.image.url}
                alt={collection.image.altText || collection.title}
                className="collection-image"
              />
            )}
            <div className="collection-title Small">{collection.title}</div>
          </button>
        ))}
    </div>
  );
}
